"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lessThanEqualToSemverMatcherContext = void 0;
var Semver_1 = require("../../utils/Semver");
function lessThanEqualToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver_1.Semver(ruleAttr);
    return function lessThanEqualToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver_1.Semver(runtimeAttr);
        var isLessThanEqual = runtimeSemver.compare(ruleSemver) <= 0;
        return isLessThanEqual;
    };
}
exports.lessThanEqualToSemverMatcherContext = lessThanEqualToSemverMatcherContext;
